export default "__VITE_ASSET__BLIfduHS__"